import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { Component, OnInit, EventEmitter, Output, AfterViewInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { CommonService } from 'src/app/core/services/common.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { Message } from 'src/app/core/class/message';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import {I18nService} from '../../core/i18n.service';
import {ResponsiveService} from '../../core/services/responsive.service';

@Component({
  selector: 'app-kyc-enterprise',
  templateUrl: './kyc-enterprise.component.html'
})
export class KycEnterpriseComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {

  navOpened: boolean = true;
  isShowMenuSideBarLeft: boolean = true;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  constructor(
    public commonService: CommonService,
    private translate: TranslateService,
    private changeLanguageService: I18nService,
    public message: Message,
    private auth: AuthenticationService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    public deviceService: DeviceDetectorService,
    private responsiveService: ResponsiveService
  ) {
    super(commonService, message);
    this.setDefaultLanguage();
  }

  @Output() changeLanguage = new EventEmitter<boolean>();

  ngOnInit() { }

  ngAfterViewInit() {
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
        }
      }
    );
  }

  ngOnDestroy() {
    this.subscribeMediaBreakPointService.unsubscribe();
  }

  onChangeLanguage(languageSelected: string) {
    this.setLanguagelocalStored(languageSelected);
    this.translate.use(this.getLanguagelocalStored());
    this.checkIconLanguage(this.getLanguagelocalStored());
  }

  setDefaultLanguage() {
    if (this.getLanguagelocalStored() === null) {
      this.translate.setDefaultLang('vi');
      this.setLanguagelocalStored('vi');

    } else {
      this.translate.setDefaultLang(this.getLanguagelocalStored());
    }
  }

  openNav() {
    this.navOpened = !this.navOpened;
  }

  loadCheckShowMenuLeft() {
    if (this.activatedRoute.snapshot.firstChild.url[0].path == 'view-document' || this.activatedRoute.snapshot.firstChild.url[0].path == 'update-document' || this.activatedRoute.snapshot.firstChild.url[0].path === 'add-document') {
      this.isShowMenuSideBarLeft = false;
    }
    else {
      this.isShowMenuSideBarLeft = true;
    }
  }

}
